<template>
  <div>
    <h1>Kalkulator weselny</h1>
    <hr />
    <section id="kalkulator">
      <div>
        <span>
          Liczba gości
          <input v-model.number="p1" type="number" />
        </span>
        <span>
          Liczba gości na poprawinach
          <input v-model.number="p1_1" type="number" />
        </span>
      </div>
      <h3>Ile gości pije wódkę? ({{sliderIlePijeWodke}})</h3>

      <vue-slider
        v-model="sliderIlePijeWodke"
        :process="false"
        :tooltip-formatter="formatter1"
        :max="liczbaGosci"
        :marks="marksArr"
      ></vue-slider>

      <h3>Ile gości pije wino? ({{sliderIlePijeWino}})</h3>
      <vue-slider
        v-model="sliderIlePijeWino"
        :process="false"
        :tooltip-formatter="formatter2"
        :max="liczbaGosci"
        :marks="marksArr"
      ></vue-slider>
      <div>
        <h3>W jakim okresie jest wesele?</h3>
        <div>
          <input type="radio" id="one" value="0.5" v-model="udzialWinoRed" />
          <label for="one">wrzesien - marzec</label>

          <input type="radio" id="two" value="0.65" v-model="udzialWinoRed" />
          <label for="two">kwiecień - sierpień</label>
        </div>
      </div>
      <div
        v-if="udzialWinoRed"
      >Dla tego wyboru rekomendujemy wina w stosunku: czerwone {{udzialWinoRed*100}}%, białe {{udzialWinoWhite * 100}}%</div>

      <h3>
        Czy dodatkowo ma być wino musujące na toast?
        <input type="checkbox" v-model="winoMusujace" />
      </h3>

      <h3>
        Czy dodatkowo ma być wino musujące na tort o północy?
        <input
          type="checkbox"
          v-model="winoMusujaceTort"
        />
      </h3>

      <h3>
        Czy dodatkowo ma być wino deserowe?
        <input type="checkbox" v-model="winoDeserowe" />
        <span v-show="winoDeserowe">
          Ile butelek:
          <input v-model.number="p6" type="number" min="0" />
        </span>
      </h3>

      <h3>
        Czy dodatkowo ma być wino bezalkoholowe?
        <input type="checkbox" v-model="winoBezAlko" />
        <span v-show="winoBezAlko">
          Ile butelek:
          <input v-model.number="pBezAlko" type="number" min="0" />
        </span>
      </h3>
    </section>

    <calc-result
      :cart="cart"
      :resultIleButelekWodki="resultIleButelekWodki"
      :resultIleButelekWinaRed="resultIleButelekWinaRed"
      :resultIleButelekWinaWhite="resultIleButelekWinaWhite"
      :resultIleButelekWinaMus="resultIleButelekWinaMus"
      :resultIleButelekWinaDeser="resultIleButelekWinaDeser"
      :resultIleButelekWinaBezAlko="resultIleButelekWinaBezAlko"
    ></calc-result>
    <foot></foot>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
// import "vue-slider-component/theme/default.css";
import Cart from "@/cart";
import CalcResult from "@/components/CalcResult.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Calculator",
  components: {
    VueSlider,
    CalcResult,
    foot: Footer
  },
  props: {},
  data() {
    return {
      sliderIlePijeWodke: 0,
      sliderIlePijeWino: 0,
      udzialWinoRed: 0,

      p1: 100,
      p1_1: 0,
      p6: 1,
      pBezAlko: 1,
      winoMusujace: false,
      winoMusujaceTort: false,
      winoDeserowe: false,
      winoBezAlko: false,

      config: {
        butelekWodkiNaOsobe: 1,
        butelekWinaNaOsobe: 1,
        butelekWinaMusNaOsobe: 0.1
      },

      formatter1: () => `goście pijący wódkę: ${this.resultIleButelekWodki}`,

      formatter2: () => `goście pijący wino: ${this.sliderIlePijeWino}`,
      cart: new Cart()
    };
  },
  computed: {
    marksArr: function() {
      return [0, this.liczbaGosci];
    },
    liczbaGosci: function() {
      return this.p1 + this.p1_1;
    },
    udzialWinoWhite: function() {
      //w zaleznosci od miesiaca roku
      return this.udzialWinoRed < 0.1 ? 0 : 1 - this.udzialWinoRed;
    },
    resultIleButelekWodki: function() {
      return this.sliderIlePijeWodke * this.config.butelekWodkiNaOsobe; //1 butelka na 1 goscia
    },
    resultIleButelekWinaRed: function() {
      return Math.round(
        this.sliderIlePijeWino *
          this.config.butelekWinaNaOsobe *
          this.udzialWinoRed
      );
    },
    resultIleButelekWinaWhite: function() {
      return Math.round(
        this.sliderIlePijeWino *
          this.config.butelekWinaNaOsobe *
          this.udzialWinoWhite
      );
    },
    resultIleButelekWinaMus: function() {
      var rawResult =
        (this.winoMusujace
          ? this.liczbaGosci * this.config.butelekWinaMusNaOsobe
          : 0) +
        (this.winoMusujaceTort
          ? this.liczbaGosci * this.config.butelekWinaMusNaOsobe
          : 0);

      return this.winoMusujace || this.winoMusujaceTort
        ? rawResult > 1
          ? Math.round(rawResult)
          : 1
        : 0;
    },
    resultIleButelekWinaDeser: function() {
      return this.winoDeserowe ? this.p6 : 0;
    },
    resultIleButelekWinaBezAlko: function() {
      if (isNaN(this.pBezAlko)) return 0;
      else if (this.pBezAlko < 0) return 0;
      else if (this.pBezAlko == "") return 0;
      else return this.pBezAlko;
    }
  },
  methods: {}
};
</script>

// https://github.com/NightCatSama/vue-slider-component/blob/master/theme/default.css
<style>
@import "./Calculator.css";
@import "./Calculator2.css";


</style>